import { connect } from 'react-redux'
import { replace } from 'connected-react-router'
import { withRouter } from 'react-router-dom'

import { bindActionCreators } from 'redux'

import { setFeatureSnapshot } from 'actions/feature/snapshots'

import { getHistoryQueryParams } from 'selectors/router'
import {
  getSnapshotList,
  getSelectedSnapshot,
} from 'selectors/feature/snapshots'

import FeatureHistoryListNavPane from './FeatureHistoryListNavPane'

const mapStateToProps = (state) => {
  const snapshotUri = getHistoryQueryParams(state)
  const snapshots = getSnapshotList(state)
  const selectedSnapshot = getSelectedSnapshot(state, { uri: snapshotUri })

  return {
    snapshotUri,
    snapshots,
    selectedSnapshot,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      setUriQueryString: (locationObj) => replace(locationObj),
      setFeatureSnapshot,
    },
    dispatch
  ),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FeatureHistoryListNavPane)
)
